export enum ColorsEnum {
    DARK_ROAST = "#A38463",
    PASTEL_BLOOM = "#91B1C3",
    WHITE_LATTE = "#D4D5CD",
    BRIGHT_YELLOW = "#EFD650",
}
